import { IComponentCategory, IComponentDefinition, IPageDefinition, IPageGroupDefinition } from "../Components/PageDefinitionTypes";

export const pageGroups: IPageGroupDefinition[] = [
    {
        "id": "overview",
        "name": "Home",
        "page": "home",
        "order": 100
    },
    {
        "id": "gettingStarted",
        "name": "Getting started",
        "order": 200
    },
    {
        "id": "designBasics",
        "name": "Design basics",
        "order": 250
    },
    {
        "id": "develop",
        "name": "Develop",
        "order": 300
    },
    {
        "id": "components",
        "name": "Components",
        "page": "components",
        "order": 400
    },
    {
        "id": "utilities",
        "name": "Utilities",
        "page": "utilities",
        "order": 500
    },
    {
        "id": "experimental",
        "name": "Experimental",
        "page": "experimental",
        "order": 550
    },
    {
        "id": "releaseNotes",
        "name": "Release notes",
        "page": "releaseNotes",
        "order": 700
    },
    {
        "id": "contact",
        "name": "Contact",
        "page": "contact",
        "order": 800
    }
];

export const statusGroups: IPageGroupDefinition[] = [
    {
        "id": "designBasics",
        "name": "Design basics",
        "order": 100
    },
    {
        "id": "components",
        "name": "Components",
        "order": 200
    },
    {
        "id": "patterns",
        "name": "Patterns",
        "order": 300
    }
];

export const pages: IPageDefinition[] = [
    {
    component: require("../Docs/Home"),
    containerClassName: "",        
    group: "overview",
    name: "Home",
    url: "/",
    status:undefined,
    id: "home"
},
    {
    component: require("../Docs/Develop/Extensions.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "develop",
    name: "Extension development",
    url: "/develop/extensions",
    status:undefined,
    id: "extensions"
},
    {
    component: require("../Docs/Develop/Styles.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "develop",
    name: "Styles",
    url: "/develop/styles",
    status:undefined,
    id: "styles"
},
    {
    component: require("../Docs/DesignBasics/Color.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Color",
    url: "/design-basics/color",
    status:undefined,
    id: "designBasicsColor"
},
    {
    component: require("../Docs/DesignBasics/Content.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Content",
    url: "/design-basics/content",
    status:undefined,
    id: "designBasicsContent"
},
    {
    component: require("../Docs/DesignBasics/Depth.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Depth",
    url: "/design-basics/depth",
    status:undefined,
    id: "designBasicsDepth"
},
    {
    component: require("../Docs/DesignBasics/Shell.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Shell",
    url: "/design-basics/shell",
    status:undefined,
    id: "designBasicsShell"
},
    {
    component: require("../Docs/DesignBasics/Spacing.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Spacing",
    url: "/design-basics/spacing",
    status:undefined,
    id: "designBasicsSpacing"
},
    {
    component: require("../Docs/DesignBasics/Typography.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "designBasics",
    name: "Typography",
    url: "/design-basics/typography",
    status:undefined,
    id: "designBasicsTypography"
},
    {
    component: require("../Docs/Components"),
    containerClassName: "",        
    group: "components",
    name: "Components",
    url: "/components",
    status:undefined,
    id: "components"
},
    {
    component: require("../Docs/Utilities"),
    containerClassName: "",        
    group: "utilities",
    name: "Utilities",
    url: "/utilities",
    status:undefined,
    id: "utilities"
},
    {
    component: require("../Docs/ExperimentalComponents"),
    containerClassName: "",        
    group: "experimental",
    name: "Experimental components",
    url: "/experimental-components",
    status:undefined,
    id: "experimental"
},
    {
    component: require("../Docs/ReleaseNotes.mdx"),
    containerClassName: " markdown-page markdown-content",        
    group: "releaseNotes",
    name: "Release notes",
    url: "/release-notes",
    status:undefined,
    id: "releaseNotes"
},
    {
    component: require("../_Generated/ComponentPages/Button"),
    containerClassName: "",        
    group: "components",
    name: "Button",
    url: "/components/button",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "button"
},
    {
    component: require("../_Generated/ComponentPages/Card"),
    containerClassName: "",        
    group: "components",
    name: "Card",
    url: "/components/card",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "card"
},
    {
    component: require("../_Generated/ComponentPages/Checkbox"),
    containerClassName: "",        
    group: "components",
    name: "Checkbox",
    url: "/components/checkbox",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "checkbox"
},
    {
    component: require("../_Generated/ComponentPages/Dialog"),
    containerClassName: "",        
    group: "components",
    name: "Dialog",
    url: "/components/dialog",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "dialog"
},
    {
    component: require("../_Generated/ComponentPages/Dropdown"),
    containerClassName: "",        
    group: "components",
    name: "Dropdown",
    url: "/components/dropdown",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "dropdown"
},
    {
    component: require("../_Generated/ComponentPages/Editable dropdown"),
    containerClassName: "",        
    group: "components",
    name: "Editable dropdown",
    url: "/components/editable-dropdown",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "editable-dropdown"
},
    {
    component: require("../_Generated/ComponentPages/Filter"),
    containerClassName: "",        
    group: "components",
    name: "Filter",
    url: "/components/filter",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "filter"
},
    {
    component: require("../_Generated/ComponentPages/Header"),
    containerClassName: "",        
    group: "components",
    name: "Header",
    url: "/components/header",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "header"
},
    {
    component: require("../_Generated/ComponentPages/Identity picker"),
    containerClassName: "",        
    group: "components",
    name: "Identity picker",
    url: "/components/identity-picker",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "identity-picker"
},
    {
    component: require("../_Generated/ComponentPages/Icon"),
    containerClassName: "",        
    group: "components",
    name: "Icon",
    url: "/components/icon",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "icon"
},
    {
    component: require("../_Generated/ComponentPages/Image"),
    containerClassName: "",        
    group: "components",
    name: "Image",
    url: "/components/image",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "image"
},
    {
    component: require("../_Generated/ComponentPages/Link"),
    containerClassName: "",        
    group: "components",
    name: "Link",
    url: "/components/link",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "link"
},
    {
    component: require("../_Generated/ComponentPages/List"),
    containerClassName: "",        
    group: "components",
    name: "List",
    url: "/components/list",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "list"
},
    {
    component: require("../_Generated/ComponentPages/Master-detail"),
    containerClassName: "",        
    group: "components",
    name: "Master-detail",
    url: "/components/master-detail",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "master-detail"
},
    {
    component: require("../_Generated/ComponentPages/Menu"),
    containerClassName: "",        
    group: "components",
    name: "Menu",
    url: "/components/menu",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "menu"
},
    {
    component: require("../_Generated/ComponentPages/Message card"),
    containerClassName: "",        
    group: "components",
    name: "Message card",
    url: "/components/message-card",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "message-card"
},
    {
    component: require("../_Generated/ComponentPages/Page"),
    containerClassName: "",        
    group: "components",
    name: "Page",
    url: "/components/page",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "page"
},
    {
    component: require("../_Generated/ComponentPages/Panel"),
    containerClassName: "",        
    group: "components",
    name: "Panel",
    url: "/components/panel",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "panel"
},
    {
    component: require("../_Generated/ComponentPages/Persona"),
    containerClassName: "",        
    group: "components",
    name: "Persona",
    url: "/components/persona",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "persona"
},
    {
    component: require("../_Generated/ComponentPages/Pill"),
    containerClassName: "",        
    group: "components",
    name: "Pill",
    url: "/components/pill",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "pill"
},
    {
    component: require("../_Generated/ComponentPages/Radio button"),
    containerClassName: "",        
    group: "components",
    name: "Radio button",
    url: "/components/radio-button",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "radio-button"
},
    {
    component: require("../_Generated/ComponentPages/Spinner"),
    containerClassName: "",        
    group: "components",
    name: "Spinner",
    url: "/components/Spinner",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "Spinner"
},
    {
    component: require("../_Generated/ComponentPages/Splitter"),
    containerClassName: "",        
    group: "components",
    name: "Splitter",
    url: "/components/splitter",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "splitter"
},
    {
    component: require("../_Generated/ComponentPages/Status"),
    containerClassName: "",        
    group: "components",
    name: "Status",
    url: "/components/status",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "status"
},
    {
    component: require("../_Generated/ComponentPages/Table"),
    containerClassName: "",        
    group: "components",
    name: "Table",
    url: "/components/table",
    status:{"group":"components","steps":{"design":"Revision soon","code":"done","docs":"done"}},
    id: "table"
},
    {
    component: require("../_Generated/ComponentPages/Tabs"),
    containerClassName: "",        
    group: "components",
    name: "Tabs",
    url: "/components/tabs",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "tabs"
},
    {
    component: require("../_Generated/ComponentPages/Tag picker"),
    containerClassName: "",        
    group: "components",
    name: "Tag picker",
    url: "/components/tagpicker",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "tagpicker"
},
    {
    component: require("../_Generated/ComponentPages/Teaching bubble"),
    containerClassName: "",        
    group: "components",
    name: "Teaching bubble",
    url: "/components/teaching-bubble",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "teaching-bubble"
},
    {
    component: require("../_Generated/ComponentPages/Text field"),
    containerClassName: "",        
    group: "components",
    name: "Text field",
    url: "/components/text-field",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "text-field"
},
    {
    component: require("../_Generated/ComponentPages/Time"),
    containerClassName: "",        
    group: "components",
    name: "Time",
    url: "/components/time",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "time"
},
    {
    component: require("../_Generated/ComponentPages/Toast"),
    containerClassName: "",        
    group: "components",
    name: "Toast",
    url: "/components/toast",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "toast"
},
    {
    component: require("../_Generated/ComponentPages/Toggle"),
    containerClassName: "",        
    group: "components",
    name: "Toggle",
    url: "/components/toggle",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"done"}},
    id: "toggle"
},
    {
    component: require("../_Generated/ComponentPages/Tree"),
    containerClassName: "",        
    group: "components",
    name: "Tree",
    url: "/components/tree",
    status:{"group":"components","steps":{"design":"done","code":"done","docs":"Planned (Q3)"}},
    id: "tree"
},
    {
    component: require("../_Generated/ComponentPages/Zero data"),
    containerClassName: "",        
    group: "components",
    name: "Zero data",
    url: "/components/zero-data",
    status:{"group":"components","steps":{"design":"Revision soon","code":"done","docs":"Planned (Q3)"}},
    id: "zero-data"
},
    {
    component: require("../_Generated/ComponentPages/Callout"),
    containerClassName: "",        
    group: "utilities",
    name: "Callout",
    url: "/utilities/callout",
    status:undefined,
    id: "callout"
},
    {
    component: require("../_Generated/ComponentPages/ConditionalChildren"),
    containerClassName: "",        
    group: "utilities",
    name: "ConditionalChildren",
    url: "/utilities/conditional-children",
    status:undefined,
    id: "conditional-children"
},
    {
    component: require("../_Generated/ComponentPages/FocusGroup"),
    containerClassName: "",        
    group: "utilities",
    name: "FocusGroup",
    url: "/utilities/focus-group",
    status:undefined,
    id: "focus-group"
},
    {
    component: require("../_Generated/ComponentPages/FocusWithin"),
    containerClassName: "",        
    group: "utilities",
    name: "FocusWithin",
    url: "/utilities/focus-within",
    status:undefined,
    id: "focus-within"
},
    {
    component: require("../_Generated/ComponentPages/FocusZone"),
    containerClassName: "",        
    group: "utilities",
    name: "FocusZone",
    url: "/utilities/focus-zone",
    status:undefined,
    id: "focus-zone"
},
    {
    component: require("../_Generated/ComponentPages/Intersection"),
    containerClassName: "",        
    group: "utilities",
    name: "Intersection",
    url: "/utilities/intersection",
    status:undefined,
    id: "intersection"
},
    {
    component: require("../_Generated/ComponentPages/MouseWithin"),
    containerClassName: "",        
    group: "utilities",
    name: "MouseWithin",
    url: "/utilities/mouse-within",
    status:undefined,
    id: "mouse-within"
},
    {
    component: require("../_Generated/ComponentPages/Observer"),
    containerClassName: "",        
    group: "utilities",
    name: "Observer",
    url: "/utilities/observer",
    status:undefined,
    id: "observer"
},
    {
    component: require("../_Generated/ComponentPages/Portal"),
    containerClassName: "",        
    group: "utilities",
    name: "Portal",
    url: "/utilities/portal",
    status:undefined,
    id: "portal"
},
    {
    component: require("../_Generated/ComponentPages/ResizeGroup"),
    containerClassName: "",        
    group: "utilities",
    name: "ResizeGroup",
    url: "/utilities/resize-group",
    status:undefined,
    id: "resize-group"
},
    {
    component: require("../_Generated/ComponentPages/Tooltip"),
    containerClassName: "",        
    group: "utilities",
    name: "Tooltip",
    url: "/utilities/tooltip",
    status:undefined,
    id: "tooltip"
},
    {
    component: require("../_Generated/ComponentPages/Accordion"),
    containerClassName: "",        
    group: "experimental",
    name: "Accordion",
    url: "/experimental/accordion",
    status:{"group":"experimental","steps":{"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"}},
    id: "accordion"
},
    {
    component: require("../_Generated/ComponentPages/Collapsible Card"),
    containerClassName: "",        
    group: "experimental",
    name: "Collapsible Card",
    url: "/experimental/collapsibleCard",
    status:{"group":"experimental","steps":{"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"}},
    id: "collapsibleCard"
},
    {
    component: require("../_Generated/ComponentPages/Log viewer"),
    containerClassName: "",        
    group: "features",
    name: "Log viewer",
    url: "/features/log-viewer",
    status:{"group":"features","steps":{"design":"done","code":"done","docs":"Planned (Q1-2)"}},
    id: "log-viewer"
}
];

export const componentCategories: IComponentCategory[] = [
    {
        "id": "layout",
        "name": "Structure and layout"
    },
    {
        "id": "inputs",
        "name": "Input controls"
    },
    {
        "id": "overlays",
        "name": "Overlays and notifications"
    },
    {
        "id": "data",
        "name": "Data display"
    },
    {
        "id": "visuals",
        "name": "Supporting visuals"
    },
    {
        "id": "utility-accessories",
        "name": "Accessories",
        "page": "utilities"
    },
    {
        "id": "utility-focus",
        "name": "Focus management",
        "page": "utilities"
    },
    {
        "id": "utility-layout",
        "name": "Layout",
        "page": "utilities"
    },
    {
        "id": "utility-misc",
        "name": "Miscellaneous",
        "page": "utilities"
    },
    {
        "id": "exp-layout",
        "name": "Layout",
        "page": "experimental"
    },
    {
        "id": "pipelines",
        "name": "Azure Pipelines",
        "page": "features"
    }
];

export const components: IComponentDefinition[] = [{
            apis: ["azure-devops-ui/Components/Button/Button.Props.d.ts","azure-devops-ui/Components/Button/ExpandableButton.Props.d.ts","azure-devops-ui/Components/Menu/MenuButton.Props.d.ts","azure-devops-ui/Components/SplitButton/SplitButton.Props.d.ts","azure-devops-ui/Components/ClipboardButton/ClipboardButton.Props.d.ts"],
            category: "inputs",
            id: "button",
            name: "Button",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/button.svg"),
            url: "/components/button"
        },
{
            apis: ["azure-devops-ui/Components/Card/Card.Props.d.ts"],
            category: "layout",
            id: "card",
            name: "Card",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/card.svg"),
            url: "/components/card"
        },
{
            apis: ["azure-devops-ui/Components/Checkbox/Checkbox.Props.d.ts"],
            category: "inputs",
            id: "checkbox",
            name: "Checkbox",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/checkbox.svg"),
            url: "/components/checkbox"
        },
{
            apis: ["azure-devops-ui/Components/Dialog/Dialog.Props.d.ts"],
            category: "overlays",
            id: "dialog",
            name: "Dialog",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/dialog.svg"),
            url: "/components/dialog"
        },
{
            apis: ["azure-devops-ui/Components/Dropdown/Dropdown.Props.d.ts","azure-devops-ui/Components/ListBox/ListBox.Props.d.ts"],
            category: "inputs",
            id: "dropdown",
            name: "Dropdown",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/dropdown.svg"),
            url: "/components/dropdown"
        },
{
            apis: ["azure-devops-ui/Components/EditableDropdown/EditableDropdown.Props.d.ts","azure-devops-ui/Components/ListBox/ListBox.Props.d.ts"],
            category: "inputs",
            id: "editable-dropdown",
            name: "Editable dropdown",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/editabledropdown.svg"),
            url: "/components/editable-dropdown"
        },
{
            apis: ["azure-devops-ui/Components/Filter/Filter.Props.d.ts","azure-devops-ui/Components/FilterBar/FilterBar.Props.d.ts","azure-devops-ui/Components/FilterBarItem/FilterBarItem.Props.d.ts"],
            category: "data",
            id: "filter",
            name: "Filter",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/filter.svg"),
            url: "/components/filter"
        },
{
            apis: ["azure-devops-ui/Components/Header/Header.Props.d.ts"],
            category: "layout",
            id: "header",
            name: "Header",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/header.svg"),
            url: "/components/header"
        },
{
            apis: ["azure-devops-ui/Components/IdentityPicker/IdentityPicker.Props.d.ts","azure-devops-ui/Components/IdentityPickerDropdown/IdentityPickerDropdown.Props.d.ts","azure-devops-ui/Components/IdentityPickerDropdown/SharedIdentityPicker.Props.d.ts"],
            category: "inputs",
            id: "identity-picker",
            name: "Identity picker",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/identitypicker.svg"),
            url: "/components/identity-picker"
        },
{
            apis: ["azure-devops-ui/Components/Icon/Icon.Props.d.ts"],
            category: "visuals",
            id: "icon",
            name: "Icon",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/icon.svg"),
            url: "/components/icon"
        },
{
            apis: ["azure-devops-ui/Components/Image/Image.Props.d.ts"],
            category: "visuals",
            id: "image",
            name: "Image",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/image.svg"),
            url: "/components/image"
        },
{
            apis: ["azure-devops-ui/Components/Link/Link.Props.d.ts"],
            category: "inputs",
            id: "link",
            name: "Link",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/link.svg"),
            url: "/components/link"
        },
{
            apis: ["azure-devops-ui/Components/List/List.Props.d.ts"],
            category: "data",
            id: "list",
            name: "List",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/list.svg"),
            url: "/components/list"
        },
{
            apis: ["azure-devops-ui/Components/MasterPanel/MasterPanel.Props.d.ts","azure-devops-ui/Components/SingleLayerMasterPanel/SingleLayerMasterPanel.Props.d.ts","azure-devops-ui/Components/DetailsPanel/DetailsPanel.Props.d.ts","azure-devops-ui/Context/MasterDetailsContext.Types.d.ts"],
            category: "layout",
            id: "master-detail",
            name: "Master-detail",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/masterdetail.svg"),
            url: "/components/master-detail"
        },
{
            apis: ["azure-devops-ui/Components/Menu/Menu.Props.d.ts"],
            category: "overlays",
            id: "menu",
            name: "Menu",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/menu.svg"),
            url: "/components/menu"
        },
{
            apis: ["azure-devops-ui/Components/MessageCard/MessageCard.Props.d.ts"],
            category: "overlays",
            id: "message-card",
            name: "Message card",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/messagecard.svg"),
            url: "/components/message-card"
        },
{
            apis: ["azure-devops-ui/Components/Page/Page.Props.d.ts"],
            category: "layout",
            id: "page",
            name: "Page",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/page.svg"),
            url: "/components/page"
        },
{
            apis: ["azure-devops-ui/Components/Panel/Panel.Props.d.ts"],
            category: "layout",
            id: "panel",
            name: "Panel",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/panel.svg"),
            url: "/components/panel"
        },
{
            apis: ["azure-devops-ui/Components/VssPersona/VssPersona.Props.d.ts"],
            category: "visuals",
            id: "persona",
            name: "Persona",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/persona.svg"),
            url: "/components/persona"
        },
{
            apis: ["azure-devops-ui/Components/Pill/Pill.Props.d.ts","azure-devops-ui/Components/PillGroup/PillGroup.Props.d.ts"],
            category: "data",
            id: "pill",
            name: "Pill",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/pill.svg"),
            url: "/components/pill"
        },
{
            apis: ["azure-devops-ui/Components/RadioButton/RadioButton.Props.d.ts"],
            category: "inputs",
            id: "radio-button",
            name: "Radio button",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/radiobutton.svg"),
            url: "/components/radio-button"
        },
{
            apis: ["azure-devops-ui/Components/Spinner/Spinner.Props.d.ts"],
            category: "visuals",
            id: "Spinner",
            name: "Spinner",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/spinner.svg"),
            url: "/components/Spinner"
        },
{
            apis: ["azure-devops-ui/Components/Splitter/Splitter.Props.d.ts"],
            category: "layout",
            id: "splitter",
            name: "Splitter",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/splitter.svg"),
            url: "/components/splitter"
        },
{
            apis: ["azure-devops-ui/Components/Status/Status.Props.d.ts"],
            category: "visuals",
            id: "status",
            name: "Status",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/status.svg"),
            url: "/components/status"
        },
{
            apis: ["azure-devops-ui/Components/Table/Table.Props.d.ts"],
            category: "data",
            id: "table",
            name: "Table",
            status: {"design":"Revision soon","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/table.svg"),
            url: "/components/table"
        },
{
            apis: ["azure-devops-ui/Components/Tabs/Tabs.Props.d.ts"],
            category: "layout",
            id: "tabs",
            name: "Tabs",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/tabs.svg"),
            url: "/components/tabs"
        },
{
            apis: ["azure-devops-ui/Components/TagPicker/TagPicker.Props.d.ts"],
            category: "inputs",
            id: "tagpicker",
            name: "Tag picker",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/tagpicker.svg"),
            url: "/components/tagpicker"
        },
{
            apis: ["azure-devops-ui/Components/TeachingBubble/TeachingBubble.Props.d.ts"],
            category: "overlays",
            id: "teaching-bubble",
            name: "Teaching bubble",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/teachingbubble.svg"),
            url: "/components/teaching-bubble"
        },
{
            apis: ["azure-devops-ui/Components/TextField/TextField.Props.d.ts"],
            category: "inputs",
            id: "text-field",
            name: "Text field",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/textfield.svg"),
            url: "/components/text-field"
        },
{
            apis: ["azure-devops-ui/Components/Time/Time/Time.Props.d.ts","azure-devops-ui/Components/Time/Ago/Ago.Props.d.ts","azure-devops-ui/Components/Time/Duration/Duration.Props.d.ts"],
            category: "data",
            id: "time",
            name: "Time",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/time.svg"),
            url: "/components/time"
        },
{
            apis: ["azure-devops-ui/Components/Toast/Toast.Props.d.ts"],
            category: "overlays",
            id: "toast",
            name: "Toast",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/toast.svg"),
            url: "/components/toast"
        },
{
            apis: ["azure-devops-ui/Components/Toggle/Toggle.Props.d.ts"],
            category: "inputs",
            id: "toggle",
            name: "Toggle",
            status: {"design":"done","code":"done","docs":"done"},
            thumbnailImage: require("../Images/Thumbnails/toggle.svg"),
            url: "/components/toggle"
        },
{
            apis: ["azure-devops-ui/Components/TreeEx/Tree.Props.d.ts"],
            category: "data",
            id: "tree",
            name: "Tree",
            status: {"design":"done","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/tree.svg"),
            url: "/components/tree"
        },
{
            apis: ["azure-devops-ui/Components/ZeroData/ZeroData.Props.d.ts"],
            category: "data",
            id: "zero-data",
            name: "Zero data",
            status: {"design":"Revision soon","code":"done","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/zerodata.svg"),
            url: "/components/zero-data"
        },
{
            apis: ["azure-devops-ui/Components/Callout/Callout.Props.d.ts"],
            category: "utility-accessories",
            id: "callout",
            name: "Callout",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/callout"
        },
{
            apis: ["azure-devops-ui/Components/ConditionalChildren/ConditionalChildren.Props.d.ts"],
            category: "utility-misc",
            id: "conditional-children",
            name: "ConditionalChildren",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/conditional-children"
        },
{
            apis: ["azure-devops-ui/Components/FocusGroup/FocusGroup.Props.d.ts"],
            category: "utility-focus",
            id: "focus-group",
            name: "FocusGroup",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/focus-group"
        },
{
            apis: ["azure-devops-ui/Components/FocusWithin/FocusWithin.Props.d.ts"],
            category: "utility-focus",
            id: "focus-within",
            name: "FocusWithin",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/focus-within"
        },
{
            apis: ["azure-devops-ui/Components/FocusZone/FocusZone.Props.d.ts"],
            category: "utility-focus",
            id: "focus-zone",
            name: "FocusZone",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/focus-zone"
        },
{
            apis: ["azure-devops-ui/Components/Intersection/Intersection.Props.d.ts"],
            category: "utility-misc",
            id: "intersection",
            name: "Intersection",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/intersection"
        },
{
            apis: ["azure-devops-ui/Components/MouseWithin/MouseWithin.Props.d.ts"],
            category: "utility-misc",
            id: "mouse-within",
            name: "MouseWithin",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/mouse-within"
        },
{
            apis: ["azure-devops-ui/Components/Observer/Observer.Props.d.ts"],
            category: "utility-misc",
            id: "observer",
            name: "Observer",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/observer"
        },
{
            apis: ["azure-devops-ui/Components/Portal/Portal.Props.d.ts"],
            category: "utility-accessories",
            id: "portal",
            name: "Portal",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/portal"
        },
{
            apis: ["azure-devops-ui/Components/ResizeGroup/ResizeGroup.Props.d.ts"],
            category: "utility-layout",
            id: "resize-group",
            name: "ResizeGroup",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/resize-group"
        },
{
            apis: ["azure-devops-ui/Components/TooltipEx/Tooltip.Props.d.ts"],
            category: "utility-accessories",
            id: "tooltip",
            name: "Tooltip",
            status: undefined,
            thumbnailImage: undefined,
            url: "/utilities/tooltip"
        },
{
            apis: ["azure-devops-ui-experimental/Components/Accordion/Accordion.Props.d.ts"],
            category: "exp-layout",
            id: "accordion",
            name: "Accordion",
            status: {"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/accordion.svg"),
            url: "/experimental/accordion"
        },
{
            apis: ["azure-devops-ui-experimental/Components/Card/Card.Props.d.ts"],
            category: "exp-layout",
            id: "collapsibleCard",
            name: "Collapsible Card",
            status: {"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"},
            thumbnailImage: require("../Images/Thumbnails/collapsiblecard.svg"),
            url: "/experimental/collapsibleCard"
        },
{
            apis: ["azure-pipelines-ui/Components/LogViewer/LogViewer.Props.d.ts"],
            category: "pipelines",
            id: "log-viewer",
            name: "Log viewer",
            status: {"design":"done","code":"done","docs":"Planned (Q1-2)"},
            thumbnailImage: undefined,
            url: "/features/log-viewer"
        }];
